export const strategicAxisTypes = [
  {
    label: "Intervención para la prevención de la violencia",
    value: "VIOLENCE_PREVENTION"
  },
  {
    label: "Fortalecimiento y construcción de capacidades institucionales",
    value: "INSTITUTIONAL_IMPROVEMENT"
  },
  {
    label: "Incidencias en políticas públicas para la seguridad ciudadana",
    value: "PUBLIC_POLICIES"
  },
  {
    label: "Estado de derecho y cultura de la legalidad",
    value: "RULE_OF_LAW"
  },
  {
    label: "Competitividad",
    value: "COMPETITIVENESS"
  },
  {
    label: "Fortalecimiento institucional en seguridad y justicia",
    value: "INSTITUTIONAL_IMPROVEMENT_SECURITY_AND_JUSTICE"
  },
  {
    label: "Evaluar, medir y monitorear la acción de gobierno en seguridad y justicia",
    value: "EVALUATE_MEASURE_AND_MONITOR_GOVERNMENT_ACTION_IN_SECURITY_AND_JUSTICE"
  },
  {
    label: "Corresponsabilidad ciudadana frente al delito",
    value: "CITIZEN_CORRESPONSIBILITY_AGAINST_CRIME"
  },
  {
    label: "Fomento a la competitividad",
    value: "COMPETITIVENESS_PROMOTION"
  }
]

export const activeStrategicAxisTypes = [
  {
    label: "Fortalecimiento institucional en seguridad y justicia",
    value: "INSTITUTIONAL_IMPROVEMENT_SECURITY_AND_JUSTICE"
  },
  {
    label: "Evaluar, medir y monitorear la acción de gobierno en seguridad y justicia",
    value: "EVALUATE_MEASURE_AND_MONITOR_GOVERNMENT_ACTION_IN_SECURITY_AND_JUSTICE"
  },
  {
    label: "Corresponsabilidad ciudadana frente al delito",
    value: "CITIZEN_CORRESPONSIBILITY_AGAINST_CRIME"
  },
  {
    label: "Fomento a la competitividad",
    value: "COMPETITIVENESS_PROMOTION"
  }
]

export const priorityactionsTypes = [

  {
    label: "Reingeniería y certificación de procesos, infraestructura y modernización tecnológica en seguridad y justicia",
    value: "REENGINEERING_AND_CERTIFICATION_OF_PROCESSES_INFRASTRUCTURE_AND_TECHNOLOGICAL_MODERNIZATION_IN_SECURITY_AND_JUSTICE.",
    type:"INSTITUTIONAL_IMPROVEMENT_SECURITY_AND_JUSTICE"
  },
  {
    label: "Reforma policial y profesionalización del sistema de seguridad y justicia.",
    value: "POLICE_REFORM_AND_PROFESSIONALIZATION_OF_THE_SECURITY_AND_JUSTICE_SYSTEM",
    type:"INSTITUTIONAL_IMPROVEMENT_SECURITY_AND_JUSTICE"
  },
  {
    label: "Gestión estratégica de recursos humanos, materiales y gasto eficiente en las instituciones de seguridad y justicia.",
    value: "STRATEGIC_MANAGEMENT_OF_HUMAN_RESOURCES_MATERIALS_AND_EFFICIENT_EXPENDITURE_IN_SECURITY_AND_JUSTICE_INSTITUTIONS",
    type:"INSTITUTIONAL_IMPROVEMENT_SECURITY_AND_JUSTICE"
  },
  {
    label: "Mecanismos de anticorrupción y control social de las instituciones de seguridad y justicia.",
    value: "MECHANISMS_FOR_ANTICORRUPTION_AND_SOCIAL_CONTROL_OF_SECURITY_AND_JUSTICE_INSTITUTIONS",
    type:"INSTITUTIONAL_IMPROVEMENT_SECURITY_AND_JUSTICE"
  },
  {
    label: "Modelos de investigación criminal desde la policía en coordinación con el Ministerio Público.",
    value: "MODELS_OF_CRIMINAL_INVESTIGATION_FROM_THE_POLICE_IN_COORDINATION_WITH_THE_PUBLIC_MINISTRY",
    type:"INSTITUTIONAL_IMPROVEMENT_SECURITY_AND_JUSTICE"
  },
  {
    label: "Modelos de prevención focalizada",
    value: "TARGETED_PREVENTION_MODELS",
    type:"INSTITUTIONAL_IMPROVEMENT_SECURITY_AND_JUSTICE"
  },
  {
    label: "Modelos de reinserción social efectiva",
    value: "EFFECTIVE_SOCIAL_REINTEGRATION_MODELS",
    type:"INSTITUTIONAL_IMPROVEMENT_SECURITY_AND_JUSTICE"
  },
  {
    label: "Co-diseño de herramientas para evaluar el desempeño de la autoridad orientada a resultados",
    value: "CO_DESIGN_OF_TOOLS_TO_EVALUATE_AUTHORITY_PERFORMANCE_ORIENTED_TOWARDS_RESULTS",
    type:"EVALUATE_MEASURE_AND_MONITOR_GOVERNMENT_ACTION_IN_SECURITY_AND_JUSTICE"
  },
  {
    label: "Evaluación de la política pública en seguridad y justicia con enfoque sistémico, transversal y transexenal",
    value: "EVALUATION_OF_PUBLIC_POLICY_IN_SECURITY_AND_JUSTICE_WITH_A_SYSTEMIC_TRANSVERSAL_AND_CROSS_ADMINISTRATIVE_APPROACH",
    type:"EVALUATE_MEASURE_AND_MONITOR_GOVERNMENT_ACTION_IN_SECURITY_AND_JUSTICE"
  },
  {
    label: "Modelos de prevención focalizada",
    value: "TARGETED_PREVENTION_MODELS",
    type:"CITIZEN_CORRESPONSIBILITY_AGAINST_CRIME"
  },
  {
    label: "Modelos de reinserción social efectiva",
    value: "EFFECTIVE_SOCIAL_REINTEGRATION_MODELS",
    type:"CITIZEN_CORRESPONSIBILITY_AGAINST_CRIME"
  },
  {
    label: "Financiar proyectos de alto impacto para la competitividad",
    value: "FINANCING_HIGH_IMPACT_PROJECTS_FOR_COMPETITIVENESS",
    type:"COMPETITIVENESS_PROMOTION"
  },
]

/**
 * @deprecated since version 1.5.2
 * Reason: Are new strategicAxis. You must to use activeStrategicAxisTypes
 */
export const inactiveStrategicAxisTypes = [
  { label: "Borrar selección", value: null },
  {
    label: "Intervención para la prevención de la violencia",
    value: "VIOLENCE_PREVENTION"
  },
  {
    label: "Fortalecimiento y construcción de capacidades institucionales",
    value: "INSTITUTIONAL_IMPROVEMENT"
  },
  {
    label: "Incidencias en políticas públicas para la seguridad ciudadana",
    value: "PUBLIC_POLICIES"
  },
  {
    label: "Estado de derecho y cultura de la legalidad",
    value: "RULE_OF_LAW"
  },
  {
    label: "Competitividad",
    value: "COMPETITIVENESS"
  }
]
